<template>
  <el-dialog
    title="发布到公众号或企业微信"
    :visible.sync="innerVisible"
    custom-class="application-dialog-view"
    width="968px"
  >
    <div class="sort-body">
      <div class="sort-left">
        <!-- <div class="left-box-onlyone">
          <img alt="" class="left-cover" :src="selectedArticle.cover_list_url" />
          <div class="left-cover-title">{{ selectedArticle.title }}</div>
        </div> -->
        <div class="sort-left-content">
          <template v-if="articleList.length === 1">
            <div class="top_article">
              <!-- <el-image :src="articleList[0].cover_url"></el-image> -->
              <el-image :src="articleList[0].cover_list_url || articleList[0].cover_url"></el-image>
            </div>
            <div class="article_item no_hover">
              <div class="item_title">{{ articleList[0].title }}</div>
            </div>
          </template>
          <div
            v-else
            v-for="(item, index) in articleList"
            :key="index"
            @click="activeArticle(index)"
          >
            <div class="top_article" v-if="index === 0">
              <!-- <el-image :src="item.cover_url"></el-image> -->
              <el-image :src="articleList[0].cover_list_url || articleList[0].cover_url"></el-image>
              <div class="top_article_title">{{ item.title }}</div>
            </div>
            <div v-else class="article_item" :class="{ active: index === activeIndex }">
              <div class="item_title">{{ item.title }}</div>
              <el-image :src="item.pic_url" class="item_cover" fit="cover"></el-image>
            </div>
          </div>
        </div>
        <div class="left-control">
          <img alt="" @click="goUp" :src="g_imgSrc.up" class="control-item" />
          <img alt="" @click="goDown" :src="g_imgSrc.down" class="control-item" />
          <img alt="" @click="deleteArticle" :src="g_imgSrc.ashcan" class="control-item" />
        </div>
      </div>
      <div class="sort-right">
        <div class="right-title">群发对象</div>
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="right-form">
          <el-form-item required label="应用:" prop="agent_id">
            <el-select
              v-model="ruleForm.agent_id"
              class="release-el-select"
              placeholder="请选择"
              :clearable="true"
              @change="getManagerList"
            >
              <el-option
                v-for="item in appList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送范围:">
            <selectViewRange
              ref="range"
              :agent-id="Number(ruleForm.agent_id)"
              :disable-selection="!ruleForm.agent_id"
            ></selectViewRange>
          </el-form-item>
          <div class="right-middle-line"></div>
          <el-form-item label="定时群发:" class="release-el-form-item">
            <el-switch v-model="ruleForm.switch"></el-switch>
          </el-form-item>
          <div class="right-explanation" v-if="ruleForm.switch">
            您可选择5分钟后，在一周内定时群发，成功设置后不支持修改，不可取消。
          </div>
          <el-form-item required v-if="ruleForm.switch" label="发送时间：">
            <div style="display: flex">
              <el-date-picker
                :unlink-panels="true"
                :editable="false"
                class="sort-date"
                v-model="ruleForm.date"
                :picker-options="pickerOptions"
                format="MM 月 dd 日"
                value-format="yyyy-MM-dd"
                @focus="timeFocus"
                @change="changeDatePicker"
                placeholder="选择日期时间"
              ></el-date-picker>
              <el-time-picker
                class="sort-date-time"
                v-model="ruleForm.startTime"
                :picker-options="pickerOptionsMinute"
                :default-value="defaultValue"
                value-format="HH:mm:ss"
                placeholder="选择时间点"
              ></el-time-picker>
            </div>
          </el-form-item>
          <el-form-item label="审批人：">
            <el-select
              v-model="ruleForm.verifyUser"
              :placeholder="`${ruleForm.agent_id ? '请选择' : '请先选择应用'}`"
              clearable
              filterable
            >
              <el-option
                v-for="manager in managerList"
                :key="manager.id"
                :value="String(manager.id)"
                :label="manager.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="sort-footer">
      <el-button
        type="primary"
        class="sort-btn sure"
        @click="submitForm('ruleForm')"
        :loading="bottonLoading"
      >
        确定发布
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formatTime } from '@/utils/time.js';
import { GetManagerInfoByAppOrAgentId } from '@/api/setUser';
import { updateEyaoSaaSWxArticlesPublicshSendApi } from '@/api/releaseManagement.js';
import selectViewRange from '@/components/selectViewRange';
import { mapGetters } from 'vuex';
export default {
  name: 'ApplicationDialog',
  //   props: ["sortBoxList", "accountList", "strategyList"],
  components: { selectViewRange },
  model: {
    prop: 'applicationDialogVisible',
    event: 'toggle',
  },
  props: {
    applicationDialogVisible: {
      type: Boolean,
      default: false,
    },
    selectedArticle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      value: null,
      currentItem: null,
      currentIndex: null,
      openPreviewStatus: false, // 预览
      dataListBox: [],
      rules: {
        agent_id: [
          {
            required: true,
            message: '请选择应用',
          },
        ],
      },
      ruleForm: {
        agent_id: null,
        switch: false,
        date: '',
        startTime: '',
        verifyUser: '',
      },
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() < (Date.now()+300000);
          return time.getTime() < Date.now() - 86400000 || time.getTime() > Date.now() + 604800000;
        },
      },
      bottonLoading: false, // 确定发布的Loading
      strategyUserCount: '',
      messageTimes: '',
      strategySendUserCount: '',
      accountListFilter: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      visible: false,
      pickerOptionsMinute: {
        selectableRange: '',
      },
      nowDay: formatTime(new Date(), 'yyyy-mm-dd'),
      defaultValue: null,
      // 文章列表
      articleList: [],
      // 高亮的index
      activeIndex: null,

      managerList: [], // 管理员列表
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.applicationDialogVisible;
      },
      set(val) {
        this.$emit('toggle', val);
      },
    },
    appList() {
      let appList = this.$store.state.user.managerLogin.agent_list.map((item) => ({
        label: item.agent_name,
        value: item.agent_id,
      }));
      appList = appList.filter((it) =>
        this.selectedArticle.art_agent_list.some((item) => item.agent_id === it.value),
      );
      return appList;
    },
    isChooseAll() {
      return true;
    },
    ...mapGetters('user', {
      userId: 'getUserId',
    }),
  },
  methods: {
    getManagerList() {
      this.ruleForm.verifyUser = '';
      GetManagerInfoByAppOrAgentId({
        AgentId: this.ruleForm.agent_id || '',
      })
        .then(({ ManagerInfos: list }) => {
          console.log(list);
          // 去掉登录者本人（如果有的话）
          for (const item of list) {
            if (item.id === this.userId) {
              list.splice(list.indexOf(item), 1);
              break;
            }
          }
          list.unshift({
            id: '',
            name: '无需审批',
          });
          this.managerList = list;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    changeDatePicker(e) {
      if (e === this.nowDay) {
        this.setPickerOptions();
      } else {
        this.pickerOptionsMinute = {
          selectableRange: '00:00:00 - 23:59:59',
        };
      }
    },
    setPickerOptions() {
      this.ruleForm.startTime = '';
      this.defaultValue = new Date().getTime() + 360000;
      let future = new Date(this.defaultValue);
      future = formatTime(future, 'hh:ii:ss');
      this.pickerOptionsMinute = {
        selectableRange: `${future} - 23:59:59`,
      };
    },
    // 设置列表 外部调用
    setArticleSortList(list) {
      this.articleList = list;
    },
    // 改变列表位置
    changeArticlePosition(index, type) {
      // 将目标位置元素替换成现在的，将现在位置元素替换为截取的元素，
      const step = type != 1 ? 1 : -1;
      this.articleList[index] = this.articleList.splice(
        index + step,
        1,
        this.articleList[index],
      )[0];
      this.activeIndex = this.activeIndex + step;
    },
    // 向上移动
    goUp() {
      if (this.articleList.length === 1) {
        this.$message.warning('只有一篇文章了,无法操作.');
        return;
      }
      if (this.activeIndex === null) {
        this.$message({
          message: '请选择需要调整的文章',
          type: 'warning',
        });
        return;
      }
      if (this.activeIndex === 0) {
        this.$message({
          message: '已经到顶啦',
          type: 'warning',
        });
        return;
      }
      if (this.activeIndex === 1) {
        window.scrollTo(0, 0);
      }
      this.changeArticlePosition(this.activeIndex, 1);
    },
    // 向下移动
    goDown() {
      if (this.articleList.length === 1) {
        this.$message.warning('只有一篇文章了,无法操作.');
        return;
      }
      if (this.activeIndex === null) {
        this.$message({
          message: '请选择需要调整的文章',
          type: 'warning',
        });
        return;
      }
      if (this.activeIndex === this.articleList.length - 1) {
        this.$message({
          message: '已经到底啦',
          type: 'warning',
        });
        return;
      }
      this.changeArticlePosition(this.activeIndex, 0);
    },
    // 移除文章
    deleteArticle() {
      if (this.articleList.length === 1) {
        this.$message.warning('只剩下一篇文章了,无法删除.');
        return;
      }
      if (this.activeIndex === null) {
        this.$message({
          message: '请选择需要移除的文章',
          type: 'warning',
        });
        return;
      }
      const delItem = this.articleList.splice(this.activeIndex, 1);
      this.$emit('changeList', delItem[0]);
      this.activeIndex = null;
    },
    // 点击选择需要排序的item,设置高亮
    activeArticle(index) {
      this.activeIndex = index;
    },
    // 一个页面两个时间选择器 样式不同 这里采用点击事件去动态设置样式
    timeFocus() {
      let timeBox = document.getElementsByClassName('el-picker-panel');
      if (timeBox.className !== 'el-picker-panel el-date-picker el-popper has-time') {
        setTimeout(() => {
          timeBox = document.getElementsByClassName('el-picker-panel');
          for (let i = 0; i < timeBox.length; i++) {
            timeBox[i].style.border = '1px solid #eee';
          }
        }, 100);
      } else {
        for (let i = 0; i < timeBox.length; i++) {
          timeBox[i].style.border = '1px solid #eee';
        }
      }
    },
    timeBlur() {
      const timeBox = document.getElementsByClassName('el-picker-panel');
      for (let i = 0; i < timeBox.length; i++) {
        timeBox[i].style.border = '0px';
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { departIds, userIds, labelIds, isChooseAll } = this.$refs.range.submitForm();
          if (
            departIds.length === 0 &&
            userIds.length === 0 &&
            labelIds.length === 0 &&
            !isChooseAll
          ) {
            this.$message('请选择发送范围');
            return;
          }
          // 选择的时间是当前的话 改为五分钟后
          if (
            this.ruleForm.switch &&
            new Date(`${this.ruleForm.date} ${this.ruleForm.startTime}`).getTime() <
              new Date().getTime() + 1000 * 60 * 5
          ) {
            this.$message('定时群发时间必须为五分钟以后');
            return;
          }
          this.bottonLoading = true;
          const artIds = this.articleList.map((article) => {
            return article.id;
          });
          const req = {
            agent_id: this.ruleForm.agent_id,
            artIds,
            publish_time: this.ruleForm.date
              ? `${this.ruleForm.date} ${this.ruleForm.startTime}`
              : '',
            to_party: isChooseAll ? 'all' : departIds.join('|'),
            to_user: isChooseAll ? 'all' : userIds.join('|'),
            to_tag: isChooseAll ? 'all' : labelIds.join('|'),
            VerifyUser: this.ruleForm.verifyUser,
          };
          try {
            await updateEyaoSaaSWxArticlesPublicshSendApi({ ...req });
            this.$message.success('成功');
            this.closeDialog();
            this.$emit('success');
          } catch (err) {
            this.$message.error(`${err.message || '发布失败'}`);
          }
          this.bottonLoading = false;
        } else {
          return false;
        }
      });
    },
    changeTime(time) {
      let d = new Date(time);
      d = `${d.getFullYear()}-${
        d.getMonth() + 1
      }-${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
      return new Date(d).getTime();
    },

    // 关闭弹窗
    closeDialog() {
      this.ruleForm = {
        agent_id: null,
        switch: false,
        date: '',
      };
      this.timeBlur();
      this.$emit('closeDialog', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.application-dialog-view {
  ::v-deep &.el-dialog {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0 !important;
  }
  .sort-body {
    height: 498px;
    flex: 1;
    display: flex;
    .sort-left {
      width: 456px;
      height: 100%;
      background: rgba(0, 0, 0, 0.04);
      border-radius: 8px;
      padding: 17px 32px 16px 40px;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;
      .sort-left-content {
        position: relative;
        width: 296px;
        height: 100%;
        background: #ffffff;
        border-radius: 8px;
        overflow-y: scroll;
        .top_article {
          height: 166px;
          cursor: pointer;
          border-radius: 8px 8px 0 0;
        }
        //.left-cover {
        //  width: 100%;
        //  height: 166px;
        //  position: relative;
        //  cursor: pointer;
        ::v-deep.el-image {
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
        }
        .top_article_title {
          width: 170px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: absolute;
          top: 112px;
          left: 15px;
          color: white;
          text-shadow: black 2px 2px 3px;
        }
        //}
        .article_item {
          height: 61px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.08);
          padding: 0 24px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          cursor: pointer;
          &.active {
            background: rgba(0, 0, 0, 0.1) !important;
          }
          &:hover {
            background: rgba(0, 0, 0, 0.03);
          }
          &.no_hover {
            &:hover {
              background: none !important;
            }
          }
          .item_title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            margin: 18px 0px 15px;
            height: 28px;
            line-height: 28px;
            padding-right: 10px;
          }
          .item_cover {
            border-radius: 8px;
            margin: 8px 0;
            height: 45px;
            width: 45px;
            flex-shrink: 0;
          }
        }
      }
      .left-control {
        display: inline-block;
        height: 168px;
        width: 56px;
        background: #ffffff;
        box-shadow: 3px 4px 10px 0 rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        margin: auto 0;
        padding: 24px 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .control-item {
          height: 24px;
          width: 24px;
          cursor: pointer;
        }
      }
    }
    .sort-right {
      display: inline-block;
      width: 448px;
      height: 100%;
      padding-left: 32px;
      font-size: 16px;
      color: #303133;
      .right-title {
        font-weight: bold;
        height: 22px;
        line-height: 22px;
        margin-bottom: 16px;
      }
      .right-form {
        .confirm-tags-box {
          max-height: 200px;
          overflow-y: auto;
        }
        .right-middle-line {
          border-bottom: 1px solid rgba(0, 0, 0, 0.08);
          width: 100%;
          margin: 8px 0 9px;
        }
        .right-explanation {
          margin-bottom: 10px;
        }
        .sort-date {
          display: inline-block;
          width: 200px;
          margin-right: 10px;
        }
        .sort-date-time {
          display: inline-block;
          width: 200px;
        }
      }
    }
  }
  .sort-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
<style lang="scss">
.pop-area-dialog-class {
  .pop-area-dialog {
    height: 512px;
    display: flex;
    .left-content-box {
      border-right: 1px solid rgba(0, 0, 0, 0.08);
      width: 300px;
      height: 100%;
      box-sizing: border-box;
      .search {
        height: 50px;
        padding: 8px 16px;
        position: relative;
        label {
          width: 243px;
          height: 32px;
          position: relative;
          input:focus {
            outline: none;
          }
          input {
            width: 100%;
            height: 32px;
            border: 1px solid rgba(0, 0, 0, 0.08);
            border-radius: 4px;
            padding: 0 30px;
            box-sizing: border-box;
          }
          i {
            font-size: 14px;
            color: #909399;
            position: absolute;
            top: 2px;
            left: 50%;
            margin-left: -100px;
          }
          .search_s {
            left: 10px;
            margin-left: 0;
          }
          span {
            font-size: 14px;
            color: #909399;
            position: absolute;
            top: 0;
            left: 50%;
            margin-left: -72px;
          }
        }
      }
      .tree {
        padding-left: 16px;
        height: 90%;
        overflow-y: auto;

        .custom-tree-node {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          padding-right: 8px;
        }
      }
    }
    .right-content-box {
      padding-left: 10px;
      flex: 1;
      .title-wrap {
        .blue-text-button {
          color: #2f96ff;
        }
      }
      .tag-content-area {
        height: 426px;
        overflow-y: auto;
      }
      .button-popup-footer {
        display: flex;
        justify-content: space-around;
        margin-top: 12px;
      }
    }
  }
}
</style>
